import React from 'react';

import AvailabilityDay from './AvailabilityDay';

import { getPostalcodeData } from '../../actions/mainForm';

import {
    Box, FormControl, FormControlLabel, FormGroup, Grid2, IconButton,
    InputLabel, MenuItem, Select, Switch, TextField, Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const Institution = ({
    formValues, setFormValues, colonies, setColonies, institution_types
}) => {
    const removeFormFields = (i) => {
        const newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues);
        setColonies(e => (e.filter((u, j) => j !== i)));
    };

    const handleSwitchChange = (i, name, checked) => {
        setFormValues(e => e.map((u, j) => j === i ? { ...u, [name]: checked } : u));
    };

    const handleInputChange = (i, name, value) => {
        // handleChangeInsti(index, { name, value }, setFormValues, colonies, setColonies);
        setFormValues(e => e.map((u, j) => j === i ? { ...u, [name]: value } : u));
        if (name === 'postalCode') {
            if (value.length === 5)
                getPostalcode(value, i);
            else {
                if (colonies[i].length > 0) // limpia colonias disponibles
                    setColonies(e => (e.map((u, j) => j === i ? [] : u)));
            }
        }
    };

    const getPostalcode = async (postalcode, i) => {
        const resp = await getPostalcodeData(postalcode);
        if (resp.status) {
            const { resp: { municipio, estado, asentamiento } } = resp;
            setFormValues(e => e.map(
                (item, j) => j === i ?
                    {
                        ...item,
                        colony: '',
                        city: municipio,
                        state: estado
                    }
                    : item
            ));
            setColonies(e => (e.map((u, j) => j === i ? asentamiento : u)));
        } else // snackbar para mensaje (No se encontró código postal)
            // limpia colonias disponibles
            setColonies(e => (e.map((u, j) => j === i ? [] : u)));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        {
            formValues.map((element, index) => {
                const {
                    type, street, num_ext, num_int, postalCode, colony, city, state,
                    check, schedules: { sunday, monday, tuesday, wednesday, thursday, friday, saturday }
                } = element;
                return (
                <Box key={index} sx={{ mt: 5, p: 3 }} className='medic_info'>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '15px', flexWrap: 'wrap', mb: 3 }}>
                        <Typography variant='h6' sx={{ fontWeight: '600', my: 'auto' }}>
                            Institución {index + 1}
                        </Typography>
                        {
                            index ?
                                <Box sx={{ my: 'auto' }}>
                                    <IconButton onClick={() => removeFormFields(index)} sx={{ color: 'red' }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                                : null
                        }
                    </Box>
                    <Grid2 container spacing={4}>
                        <Grid2 size={{ xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }}>
                            <FormControl fullWidth size='small'>
                                <InputLabel id="type">Tipo de institución</InputLabel>
                                <Select
                                    labelId="type"
                                    label="Tipo de institución"
                                    name='type'
                                    value={type || ""}
                                    onChange={
                                        ({ target: { name, value } }) => handleInputChange(index, name, value)
                                    }
                                >
                                    {
                                        institution_types.map(({ idTipoHospital, tipoHospital }) =>
                                            <MenuItem key={idTipoHospital}
                                                value={idTipoHospital}>
                                                { tipoHospital }
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }}>
                            <TextField label='Calle' variant='outlined' fullWidth size='small' name='street' value={street || ""}
                                onChange={
                                    ({ target: { name, value } }) => handleInputChange(index, name, value)
                                }
                            />
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}>
                            <TextField label='Número exterior' variant='outlined' fullWidth size='small' name='num_ext' value={num_ext || ""}
                                onChange={
                                    ({ target: { name, value } }) => handleInputChange(index, name, value)
                                }
                            />
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}>
                            <TextField label='Número interior' variant='outlined' fullWidth size='small' name='num_int' value={num_int || ""}
                                onChange={
                                    ({ target: { name, value } }) => handleInputChange(index, name, value)
                                }
                            />
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <TextField label='Código postal' variant='outlined' fullWidth size='small' name='postalCode' value={postalCode || ""}
                                onChange={
                                    ({ target: { name, value } }) => handleInputChange(index, name, value)
                                }
                                slotProps={{ htmlInput: { maxLength: 5 } }}
                            />
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            {
                                (colonies && colonies[index] && colonies[index].length > 0) ?
                                    <FormControl fullWidth size='small'>
                                        <InputLabel>Colonia</InputLabel>
                                        <Select
                                            id=""
                                            name="colony"
                                            value={colony || ""}
                                            label="Colonia"
                                            onChange={
                                                ({ target: { name, value } }) => handleInputChange(index, name, value)
                                            }
                                            variant="standard"
                                        >
                                            {
                                                colonies[index].map(({ nombre }) =>
                                                    <MenuItem key={nombre}
                                                        value={nombre}>{nombre}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                    :
                                    <TextField label='Colonia' variant='outlined' fullWidth size='small' name='colony' value={colony || ""}
                                        onChange={
                                            ({ target: { name, value } }) => handleInputChange(index, name, value)
                                        }
                                        slotProps={{ htmlInput: { maxLength: 60 } }}
                                    />
                            }
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <TextField label='Ciudad' variant='outlined' fullWidth size='small' name='city' value={city || ""}
                                onChange={
                                    ({ target: { name, value } }) => handleInputChange(index, name, value)
                                }
                                disabled
                            />
                            {
                                postalCode.length === 5
                                    ?
                                    null
                                    :
                                    <Typography variant='body2' sx={{ color: '#ec7063' }}>*Introduce el código postal para completar el campo</Typography>
                            }
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <TextField label='Estado' variant='outlined' fullWidth size='small' name='state' value={state || ""}
                                onChange={
                                    ({ target: { name, value } }) => handleInputChange(index, name, value)
                                }
                                disabled
                            />
                            {
                                postalCode.length === 5
                                    ?
                                    null
                                    :
                                    <Typography variant='body2' sx={{ color: '#ec7063' }}>*Introduce el código postal para completar el campo</Typography>
                            }
                        </Grid2>

                        <Grid2 size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch checked={check || ""}
                                            name='check'
                                            onChange={
                                                ({ target: { name, checked } }) => handleSwitchChange(index, name, checked)
                                            }
                                        />
                                    }
                                    label='Acepta visita médica'
                                />
                            </FormGroup>
                        </Grid2>

                        <Grid2 size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                            {
                                check === true
                                    ?
                                    <>
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '16px', mb: 3 }}>
                                            <Box sx={{ mt: .5 }}>
                                                <AccessTimeIcon />
                                            </Box>
                                            <Box sx={{ my: 'auto' }}>
                                                <Typography variant='h6'>Disponibilidad de visita</Typography>
                                                <Typography variant='body1'>
                                                    Establece cuándo suele estar disponible para tener horarios de visita.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Grid2 container spacing={4}>

                                            <AvailabilityDay
                                                index={index}
                                                day={sunday}
                                                day_of_week={'sunday'}
                                                text={'Dom'}
                                                setFormValues={setFormValues}
                                            />
                                            
                                            <AvailabilityDay
                                                index={index}
                                                day={monday}
                                                day_of_week={'monday'}
                                                text={'Lun'}
                                                setFormValues={setFormValues}
                                            />
                                            
                                            <AvailabilityDay
                                                index={index}
                                                day={tuesday}
                                                day_of_week={'tuesday'}
                                                text={'Mar'}
                                                setFormValues={setFormValues}
                                            />
                                            
                                            <AvailabilityDay
                                                index={index}
                                                day={wednesday}
                                                day_of_week={'wednesday'}
                                                text={'Mie'}
                                                setFormValues={setFormValues}
                                            />
                                            
                                            <AvailabilityDay
                                                index={index}
                                                day={thursday}
                                                day_of_week={'thursday'}
                                                text={'Jue'}
                                                setFormValues={setFormValues}
                                            />
                                            
                                            <AvailabilityDay
                                                index={index}
                                                day={friday}
                                                day_of_week={'friday'}
                                                text={'Vie'}
                                                setFormValues={setFormValues}
                                            />
                                            
                                            <AvailabilityDay
                                                index={index}
                                                day={saturday}
                                                day_of_week={'saturday'}
                                                text={'Sáb'}
                                                setFormValues={setFormValues}
                                            />
                                        </Grid2>
                                    </>
                                    :
                                    null
                            }
                        </Grid2>

                    </Grid2>
                </Box>
                )
            })
        }
        </LocalizationProvider>
    );
};

export default Institution;